import { ReactComponent as OwnitSvg } from './Ownit.svg';


const Ownit = () => (
    <div className="companyName">
        <OwnitSvg/>
    </div>
)

export default Ownit;
